import React, { FC, useEffect } from 'react';
import { LandscapeAboutContactPersonsTemplate } from '../../templates';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../store/store';
import { useNavigate, useParams } from 'react-router-dom';
import {
  deleteLandscapeContactPerson,
  fetchLandscapeContactPersonByLandscapeId,
} from '../../../store/landscapeAPI/landscape/reducers/landscape-contact-person.slice';
import cn from 'classnames';
import styles from './LandscapeAboutContactPersonsPage.module.css';
import Spinner from '../../atoms/Spinner/Spinner';

interface LandscapeAboutContactPersonsPageProps {}

const LandscapeAboutContactPersonsPage: FC<
  LandscapeAboutContactPersonsPageProps
> = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { id } = useParams();
  const { landscapeContactPersons, status } = useSelector(
    (state: RootState) => state.landscapeContactPersonSlice
  );

  useEffect(() => {
    if (id) {
      dispatch(fetchLandscapeContactPersonByLandscapeId(id));
    }
  }, [dispatch, id]);

  const handleEdit = (contactPersonId: string) => {
    navigate(
      `/landscapes/edit/${id}/about/contact-person/edit/${contactPersonId}`
    );
  };

  const handleDelete = async (contactPersonId: string) => {
    await dispatch(deleteLandscapeContactPerson(contactPersonId));
    if (id) {
      dispatch(fetchLandscapeContactPersonByLandscapeId(id));
    }
  };

  if (status === 'loading') {
    return <Spinner />;
  }

  return (
    <div className={cn(styles.landscapeAboutContactPersonsWrapper)}>
      <LandscapeAboutContactPersonsTemplate
        contactPersons={landscapeContactPersons ?? []}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
      />
    </div>
  );
};

export default LandscapeAboutContactPersonsPage;
